import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "var(--snackbar-icon-info-bg, #E3F1FF)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.8 9.4H19.3V23.7H13.8V9.4Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 5C13.8244 5 11.6977 5.64514 9.88873 6.85383C8.07979 8.06253 6.66989 9.78049 5.83733 11.7905C5.00477 13.8005 4.78693 16.0122 5.21137 18.146C5.6358 20.2798 6.68345 22.2398 8.22183 23.7782C9.76021 25.3165 11.7202 26.3642 13.854 26.7886C15.9878 27.2131 18.1995 26.9952 20.2095 26.1627C22.2195 25.3301 23.9375 23.9202 25.1462 22.1113C26.3549 20.3023 27 18.1756 27 16C27 14.5555 26.7155 13.1251 26.1627 11.7905C25.6099 10.4559 24.7996 9.24327 23.7782 8.22182C22.7567 7.20038 21.5441 6.39013 20.2095 5.83732C18.8749 5.28452 17.4445 5 16 5ZM17.1 20.4C17.1 20.6917 16.9841 20.9715 16.7778 21.1778C16.5715 21.3841 16.2917 21.5 16 21.5C15.7083 21.5 15.4285 21.3841 15.2222 21.1778C15.0159 20.9715 14.9 20.6917 14.9 20.4V14.9C14.9 14.6083 15.0159 14.3285 15.2222 14.1222C15.4285 13.9159 15.7083 13.8 16 13.8C16.2917 13.8 16.5715 13.9159 16.7778 14.1222C16.9841 14.3285 17.1 14.6083 17.1 14.9V20.4ZM16 12.7C15.7824 12.7 15.5698 12.6355 15.3889 12.5146C15.208 12.3937 15.067 12.2219 14.9837 12.0209C14.9005 11.82 14.8787 11.5988 14.9211 11.3854C14.9636 11.172 15.0683 10.976 15.2222 10.8222C15.376 10.6683 15.572 10.5636 15.7854 10.5211C15.9988 10.4787 16.22 10.5005 16.421 10.5837C16.622 10.667 16.7937 10.808 16.9146 10.9889C17.0355 11.1698 17.1 11.3824 17.1 11.6C17.1 11.8917 16.9841 12.1715 16.7778 12.3778C16.5715 12.5841 16.2917 12.7 16 12.7Z",
			fill: "var(--snackbar-icon-info-color, #3CB9FF)"
		})
	]
});
export default SvgInfo;
